export const countryCodes = [
  {
    name: 'Australia',
    code: 'au'
  },
  {
    name: 'Brazil',
    code: 'br'
  },
  {
    name: 'Canada',
    code: 'ca'
  },
  {
    name: 'Switzerland',
    code: 'ch'
  },
  {
    name: 'China',
    code: 'cn'
  },
  {
    name: 'Germany',
    code: 'de'
  },
  {
    name: 'Egypt',
    code: 'eg'
  },
  {
    name: 'Spain',
    code: 'es'
  },
  {
    name: 'France',
    code: 'fr'
  },
  {
    name: 'United Kingdom',
    code: 'gb'
  },
  {
    name: 'Greece',
    code: 'gr'
  },
  {
    name: 'Hong Kong',
    code: 'hk'
  },
  {
    name: 'Ireland',
    code: 'ie'
  },
  {
    name: 'Israel',
    code: 'il'
  },
  {
    name: 'India',
    code: 'in'
  },
  {
    name: 'Italy',
    code: 'it'
  },
  {
    name: 'Japan',
    code: 'jp'
  },
  {
    name: 'Netherlands',
    code: 'nl'
  },
  {
    name: 'Norway',
    code: 'no'
  },
  {
    name: 'Peru',
    code: 'pe'
  },
  {
    name: 'Philippines',
    code: 'ph'
  },
  {
    name: 'Pakistan',
    code: 'pk'
  },
  {
    name: 'Portugal',
    code: 'pt'
  },
  {
    name: 'Romania',
    code: 'ro'
  },
  {
    name: 'Russian Federation',
    code: 'ru'
  },
  {
    name: 'Sweden',
    code: 'se'
  },
  {
    name: 'Singapore',
    code: 'sg'
  },
  {
    name: 'Taiwan, Province of China',
    code: 'tw'
  },
  {
    name: 'Ukraine',
    code: 'ua'
  },
  {
    name: 'United States',
    code: 'us'
  }
]